import colors from '../../../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    return {
    
        button: {
            '&.MuiButton-root': {
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                boxSizing: 'border-box',                
                color: '#003168',
                height: '32px',
                width: '113px'
            }
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'flex-end',
            paddingLeft: '82%',
        
            [theme.breakpoints.down('sm')]: {
                paddingLeft: '60%',
            }
        },
        card: {
            backgroundColor: colors[mode].insightCardHover,
            border: `1px solid ${colors[mode].welcomeCardBorder}`,
            borderRadius: '5px',
            boxShadow: 'none',
            display: 'grid',
            gridTemplateRows: 'auto',
            height: '138px',
            width: '80.9%'
        },
        cardNumber: {    
            backgroundColor: colors[mode].cardImageTextRBCHover,
            borderRadius: '50%',    
            color: colors[mode].passwordUpdatebannerText,
            height: '24px',
            justifySelf: 'center',
            paddingTop: '3px',
            textAlign: 'center',
            width: '27px'
    
        },
        cardsContainer: {
            display: 'grid',
            gap: '1%',
            gridTemplateColumns: '1.5fr 1.5fr 1.5fr',
            height: '172px',
            paddingLeft: '4%',
            paddingTop: '3%',
            width: '92.8%',
            [theme.breakpoints.down('md')]: {
                gridTemplateColumns: '1fr 1fr 1fr',
                height: 'auto',
                justifyItems: 'center',
                paddingLeft: '2%',
                width: '96%'
            },
            [theme.breakpoints.down('sm')]: {
                gap: '2%',
                gridTemplateColumns: '1fr',
                height: 'auto',
                justifyItems: 'center',
                paddingLeft: '0',
                width: '100%'
            }
        },
        cardTitle:{
            color: colors[mode].cardDescription,
            fontSize: '16px'
        },
        description: {
            color: colors[mode].cardDescription,
            fontSize: '0.875rem',
            letterSpacing: '0.17px',    
            lineHeight: '1.25rem',
            textAlign: 'center',
    
        },
        helpText: {
            fontStyle: 'italic',
            padding: '16px 24px',
        },
        introText: {
            paddingLeft: '24px',
            paddingRight: '24px',
            paddingTop: '16px'
        },
        italics: {
            fontStyle: 'italic'
        },
        secondBoxdescription: {
            paddingBottom: '19px'
        },
        subCardTitle: {
            color: colors[mode].mfaActiveBackground,        
            fontSize: '0.875rem', 
            fontWeight: 500,      
            letterSpacing: '0.1px',
            lineHeight: '20px',        
            paddingLeft: '17px',
            textAlign: 'center'        
        },
        subTitle: {
            color: colors[mode].cardDescription,
            fontSize: '0.875rem',
            letterSpacing: '0.17px',
            lineHeight: '1.25rem'
        }
    }}
